import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";

import {
	getWinClassName,
	betGroupProp
} from "@/modules/commonMobile";

import "./index.scss";
import { IGameTableType } from "@/types/GlobalTypes";

import Portrait from "./Portrait";
import { getDragonVal, getTigerVal } from "@/modules/games/DragonTiger";

export interface IProps extends Omit<IGameTableType, "win"> {
	win: DragonTigerWinType;
}

interface DragonTigerWinType {
	dragon: string;
	tiger: string;
}

export default class M23 extends React.PureComponent<IProps> {
	render() {
		const { langdata } = this.props;

		const JSXDragonImg = assetImg("m23", "dragon"),
			JSXTigerImg = assetImg("m23", "tiger");

		//Todo: use translations later
		const groupText = ["Black", "Red", "Big", "Small", "Odd", "Even"];
		const groupBetKeys = ["-black", "-red", "-big", "-small", "-odd", "-even"];
		const groupBetTypes = ["1:1", "1:1", "1:1", "1:1", "1:1", "1:1"];

		const multitableGroupText = ["ODD", "BIG", "BLACK", "EVEN", "SMALL", "RED"];
		const multitableGroupBetKeys = ["-odd", "-big", "-black", "-even", "-small", "-red"];
		// const multitableGroupBetTypes = ["1:1", "1:1", "1:1", "1:1", "1:1", "1:1"];

		const gwcn = getWinClassName;

		const win = this.props.win || null;

		// console.log("m23 win", win);

		let dragonGroupWins = [],
			tigerGroupWins = [],
			multitableDragonGroupWins = [],
			multitableTigerGroupWins = [];

		let dragonValue = 0, tigerValue = 0;
		let checkTieWin = false;

		// {"game":"dragontiger","win":{"dragon":"8s","tiger":"4s"},"timer":"25","periode":168921}
		// Win highlight
		if (win && win.dragon && win.tiger) {
			dragonValue = getDragonVal(win);
			tigerValue = getTigerVal(win);

			dragonGroupWins = [
				//Black Red
				(win.dragon[1] === "c" || win.dragon[1] === "s") && dragonValue !== 7,
				(win.dragon[1] === "h" || win.dragon[1] === "d") && dragonValue !== 7,

				//Big Small
				dragonValue > 7,
				dragonValue < 7,

				//Odd Even
				dragonValue % 2 && dragonValue !== 7,
				!(dragonValue % 2),
			];

			tigerGroupWins = [
				//Black Red
				(win.tiger[1] === "c" || win.tiger[1] === "s") && tigerValue !== 7,
				(win.tiger[1] === "h" || win.tiger[1] === "d") && tigerValue !== 7,

				//Big Small
				tigerValue > 7,
				tigerValue < 7,

				//Odd Even
				tigerValue % 2 && tigerValue !== 7,
				!(tigerValue % 2),
			];

			multitableDragonGroupWins = [
				dragonValue % 2 && dragonValue !== 7, //odd
				dragonValue > 7,						  //big
				win.dragon[1] === "c" || win.dragon[1] === "s", //black

				!(dragonValue % 2),
				dragonValue < 7,
				win.dragon[1] === "h" || win.dragon[1] === "d"
			];

			multitableTigerGroupWins = [
				tigerValue % 2 && tigerValue !== 7,
				tigerValue > 7,
				win.tiger[1] === "c" || win.tiger[1] === "s",

				!(tigerValue % 2),
				tigerValue < 7,
				win.tiger[1] === "h" || win.tiger[1] === "d"
			];

			checkTieWin = (win && win.dragon && win.tiger) && (dragonValue === tigerValue);
		}

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		if (this.props.portrait)
			return <Portrait 
				dragonGroupWins={dragonGroupWins}
				tigerGroupWins={tigerGroupWins}
				dragonValue={dragonValue}
				tigerValue={tigerValue}
				checkTieWin={checkTieWin}

				{...this.props}
			/>;

		const dragonGroupRenderFunction = (item: string, idx) => {
			const bet = "dragon" + groupBetKeys[idx];
			const betKey = bet + "+n50";

			return (
				<div key={betKey}
					className={"sl-bet blue" + gwcn(dragonGroupWins[idx])}
					// bet={bet} group="n50" pcode={this.props.pcode}
					{...betGroupProp(this, bet, "n50")}
					onClick={this.props.insertBet}>
					<div>{item}</div>
					<div className="bet-type">{groupBetTypes[idx]}</div>
					<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
					<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
				</div>
			);
		}

		const tigerGroupRenderFunction = (item: string, idx) => {
			const bet = "tiger" + groupBetKeys[idx];
			const betKey = bet + "+n50";
			
			return (
				<div key={betKey}
					className={"sl-bet red" + gwcn(tigerGroupWins[idx])}
					// bet={bet} group="n50" pcode={this.props.pcode}
					{...betGroupProp(this, bet, "n50")}
					onClick={this.props.insertBet}>
					<div>{item}</div>
					<div className="bet-type">{groupBetTypes[idx]}</div>
					<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
					<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
				</div>
			);
		};


		return this.props.maximised ? (
			this.props.completeTable ? (
				<div className="m23 complete">
					<div className="left-group">
						{
							groupText.map(dragonGroupRenderFunction)
						}
					</div>
					<div className={"sl-bet middle left blue" + gwcn(win && (dragonValue > tigerValue))}
						// bet="dragon" group="dragon" pcode={this.props.pcode}
						{...betGroupProp(this, "dragon", "dragon")}
						onClick={this.props.insertBet}>
						<div>Dragon</div>
						{JSXDragonImg}
						<div className="bet-type">1:1</div>
						<Chips betKey={`dragon+dragon`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
						<Tooltip {...commonTooltipProps} bet={this.props.bets[`dragon+dragon`]} />
					</div>

					<div className={"sl-bet middle green" + gwcn(checkTieWin)}
						// bet="tie" group="tie" pcode={this.props.pcode}
						{...betGroupProp(this, "tie", "tie")}
						onClick={this.props.insertBet}>
						<div>Tie</div>
						<div className="bet-type">8:1</div>
						<Chips betKey={`tie+tie`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
						<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
					</div>

					<div className={"sl-bet middle right red" + gwcn(win && (dragonValue < tigerValue))}
						// bet="tiger" group="tiger" pcode={this.props.pcode}
						{...betGroupProp(this, "tiger", "tiger")}
						onClick={this.props.insertBet}>
						<div>Tiger</div>
						{JSXTigerImg}
						<div className="bet-type">1:1</div>
						<Chips betKey={`tiger+tiger`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
						<Tooltip {...commonTooltipProps} bet={this.props.bets[`tiger+tiger`]} />
					</div>
					<div className="right-group">
						{
							groupText.map(tigerGroupRenderFunction)
						}
					</div>
				</div>
			) : (
					<div className="m23 simpler">
						<div className={"sl-bet left blue" + gwcn(win && (dragonValue > tigerValue))}
							// bet="dragon" group="dragon" pcode={this.props.pcode}
							{...betGroupProp(this, "dragon", "dragon")}
							onClick={this.props.insertBet}>
							<div>Dragon</div>
							{JSXDragonImg}
							<div className="bet-type">1:1</div>
							<Chips betKey={`dragon+dragon`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`dragon+dragon`]} />
						</div>

						<div className={"sl-bet middle green" + gwcn(checkTieWin)}
							// bet="tie" group="tie" pcode={this.props.pcode}
							{...betGroupProp(this, "tie", "tie")}
							onClick={this.props.insertBet}>
							<div>Tie</div>
							<div className="bet-type">8:1</div>
							<Chips betKey={`tie+tie`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
						</div>

						<div className={"sl-bet right red" + gwcn(win && (dragonValue < tigerValue))}
							// bet="tiger" group="tiger" pcode={this.props.pcode}
							{...betGroupProp(this, "tiger", "tiger")}
							onClick={this.props.insertBet}>
							<div>Tiger</div>
							{JSXTigerImg}
							<div className="bet-type">1:1</div>
							<Chips betKey={`tiger+tiger`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`tiger+tiger`]} />
						</div>
					</div>
				)
		) :
				// DESKTOP MULTI TABLE
				(
					<div className="m23 complete">
						<div className="left-group">
							{
								multitableGroupText.map((item, idx) => {
									const bet = "dragon" + multitableGroupBetKeys[idx];
									const betKey = bet + "+n50";

									return (
										<div key={betKey}
											className={"sl-bet dragon" + gwcn(multitableDragonGroupWins[idx])}
											// bet={bet} group="n50" pcode={this.props.pcode}
											{...betGroupProp(this, bet, "n50")}
											onClick={this.props.insertBet}>
											<div>{item}</div>
											<div className="bet-type">{groupBetTypes[idx]}</div>
											<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
										</div>
									);
								})
							}
						</div>
						<div className="right-group">
							{
								multitableGroupText.map((item, idx) => {
									const bet = "tiger" + multitableGroupBetKeys[idx];
									const betKey = bet + "+n50";

									return (
										<div key={betKey}
											className={"sl-bet tiger" + gwcn(multitableTigerGroupWins[idx])}
											// bet={bet} group="n50" pcode={this.props.pcode}
											{...betGroupProp(this, bet, "n50")}
											onClick={this.props.insertBet}>
											<div>{item}</div>
											<div className="bet-type">{groupBetTypes[idx]}</div>
											<Chips betKey={betKey} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
										</div>
									);
								})
							}
						</div>

						<div className={"sl-bet bottom dragon" + gwcn(win && (dragonValue > tigerValue))}
							// bet="dragon" group="dragon" pcode={this.props.pcode}
							{...betGroupProp(this, "dragon", "dragon")}
							onClick={this.props.insertBet}>
							<div>Dragon</div>
							{JSXDragonImg}
							<div className="bet-type">1:1</div>
							<Chips betKey={`dragon+dragon`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`dragon+dragon`]} />
						</div>
						<div className={"sl-bet bottom sl-green-old" + gwcn(checkTieWin)}
							// bet="tie" group="tie" pcode={this.props.pcode}
							{...betGroupProp(this, "tie", "tie")}
							onClick={this.props.insertBet}>
							<div>Tie</div>
							<div className="bet-type">8:1</div>
							<Chips betKey={`tie+tie`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
						</div>
						<div className={"sl-bet bottom tiger" + gwcn(win && (dragonValue < tigerValue))}
							// bet="tiger" group="tiger" pcode={this.props.pcode}
							{...betGroupProp(this, "tiger", "tiger")}
							onClick={this.props.insertBet}>
							<div>Tiger</div>
							{JSXTigerImg}
							<div className="bet-type">1:1</div>
							<Chips betKey={`tiger+tiger`} mobile={this.props.mobile} betOutOfBounds={this.props.betOutOfBounds} chipBase={this.props.chipBase} bets={this.props.bets} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[`tiger+tiger`]} />
						</div>
					</div>
				);
	}
}